import React from "react";
import { Button } from "@mui/material";
import { Icon } from "@/components/atoms";

const SingleDateCustomInput = React.forwardRef(({ value = '', onClick, column, sx, singleDates, setOpenDatePicker }, ref) => {
  if (!column?.name_of_db_column) return null;

  const selectedDate = singleDates[column.name_of_db_column];
  const showCross = selectedDate != null;
  const showCalendar = !showCross;

  const fallbackLabel = value || column.label_of_column;
const buttonText = selectedDate
    ? `${selectedDate.toLocaleDateString()}`
    : fallbackLabel;

  return (
    <Button
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenDatePicker(column.name_of_db_column);
        onClick && onClick(e);
      }}
      variant="outlined"
      size="small"
      fullWidth
      sx={{ ...sx, textTransform: 'none' }}
      style={{ borderColor: 'rgba(255, 255, 255, 0.23)', color: showCalendar ? 'rgba(255, 255, 255, 0.23)' : "#EFEFEF" }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: '100%', }}>
        <div style={{ fontSize: '12px' }}>{buttonText}</div>
        {showCalendar ? <Icon icon="calendar_today" size="small" /> : null}
      </div>
    </Button>
  );
});

export default SingleDateCustomInput;
